
































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";

@Component({ components: { CustomDatepicker } })
export default class CField extends Vue {
  @Prop({ default: true }) labelVisible!: boolean;
  @Prop() label!: string;
  @Prop() placeholder!: string;
  @Prop() additionalIcon!: boolean;
  @Prop() debounce!: number;
  @Prop() cy!: string;
  @Prop() popoverText!: string;
  @Prop({ default: 4 }) lg!: number;
  backendError!: string;
  @Prop() backErr!: string;
  @Prop() append!: string;
  @Prop() nativeType!: string;
  @Prop({ default: false }) isShowTime!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: false }) disable!: boolean;
  @Prop({ default: false }) customCheck!: any;
  @Prop() customError!: string;
  @Prop({ default: () => [] }) validations!: Array<
    "required" | "phone" | "email" | string
  >;
  @Prop({ default: "default" }) validationKey!: string;
  @Prop({ default: "input" }) type?:
    | "date"
    | "input"
    | "select"
    | "append-input"
    | null;
  @Prop({ default: "" }) value?: any;
  @Prop({ default: false }) dateIncludingAllDay?: boolean;
  @Prop() xl?: number;
  @Prop() md?: number;
  body: any;
  popoverId: string = this.generate();
  invalid: boolean = false;
  errorMessage: string | undefined = "";

  data() {
    return {
      body: undefined,
      errorMessage: undefined,
      backendError: undefined
    };
  }

  @Watch("body")
  changeValue() {
    this.invalid = false;
    this.errorMessage = undefined;
    this.$emit("input", this.body ? this.body : undefined);
  }

  @Watch("value", { immediate: true })
  changeAttr() {
    this.body = this.value !== this.body ? this.value : this.body;
  }

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  @Watch("labelVisible")
  watchLabel() {
    this.labelVisible = true;
  }

  @Watch("validForm")
  checkValid() {
    if (this.validForm > 0) this.checkValidations();
  }

  @Watch("backError")
  checkBack() {
    if (this.backError) {
      this.errorMessage = this.backError.title;
      this.invalid = true;
    }
  }

  get validForm() {
    return this.$store.getters["validate/GET_FORM"](this.validationKey)
      ?.trigger;
  }

  get backError() {
    return this.$store.getters["validate/GET_BACKEND_ERROR"](this.backendError);
  }

  handleKeyDown(event: any) {
    if (event.key === "Enter") {
      this.$emit("enter");
    }
  }

  checkValidations() {
    let commonValidations = [
      {
        key: "required",
        action: () => {
          if (this.body === undefined || this.body.length === 0) {
            this.invalid = true;
            this.errorMessage = this.$tc(this.$translate.ThisFieldIsRequired);
            return;
          }
        }
      },
      {
        key: "phone",
        action: () => {
          if (this.body) {
            if (this.body !== "phone") {
              this.invalid = true;
              // TODO не видел такой ошибки, лишнее?
              this.errorMessage = "Поле не телефон";
              return;
            }
          }
        }
      },
      {
        key: "email",
        action: () => {
          if (this.body) {
            if (this.body !== "email") {
              this.invalid = true;
              // TODO не видел такой ошибки, лишнее?
              this.errorMessage = "Поле не email";
              return;
            }
          }
        }
      }
    ];

    let activeValidation: any = [];

    if (this.validations.length > 0) {
      activeValidation = commonValidations.filter(el =>
        this.validations.includes(el.key)
      );
    }

    if (this.body) {
      if (this.customCheck !== false) {
        if (this.customCheck(this.body)) {
          this.invalid = true;
          this.errorMessage = this.customError;
        }
      }
    }

    if (this.required) {
      activeValidation.push(
        commonValidations.find(el => el.key === "required")
      );
    }

    activeValidation.forEach((el: any) => {
      el.action();
    });

    return this.invalid;
  }

  created() {
    if (this.value === undefined) {
      this.value = "";
    }
    if (this.backErr) {
      this.backendError = this.backErr;
    } else {
      //@ts-ignore
      this.backendError = this.$vnode.data?.model?.expression;
    }
    this.$store.commit("validate/ADD_VALIDATE_FORM", this.validationKey);
  }
}
